import Calculator from "./components/Calculator.vue";
import { useCalculator } from "./hooks/useCalculator";
import type {
  OperatorType,
  ButtonType,
  CalculatorState,
} from "./hooks/useCalculator";

// 导入样式文件，确保样式被打包到 CSS 文件中
import "./style.css";

// 导出组件
export { Calculator };

// 导出hooks
export { useCalculator };
// 保持向后兼容的别名
export { useCalculator as useCalculatorStore };

// 导出类型
export type { OperatorType, ButtonType, CalculatorState };



/**
 * Vue插件安装函数
 * @param app Vue 应用实例
 */
export function install(app: any) {
  app.component("Calculator", Calculator);
}

/**
 * 默认导出，支持多种使用方式
 */
export default {
  install,
  Calculator,
  useCalculator,
  useCalculatorStore: useCalculator, // 向后兼容
};

// 版本信息
export const version = "1.0.0";
